export default __webpack_public_path__ + "static/media/image7.80f02c71.jpg";